import common from '@/api/common'
import rules from './rules'

export default {
  data () {
    return {
      formRules: {
        phone: [{
          required: true,
          validator: (rule, value, callback) => {
            if (!rules.phone(value)) {
              callback(new Error('请输入正确的手机号'))
            } else {
              // if (this.formRules.phonePass === value) {
              //   callback()
              // } else {
              //   common.checkPhone(value, this.formRules.userUuid).then(res => {
              //     if (res) {
              //       this.formRules.phonePass = value
              //       callback()
              //     } else {
              //       callback(new Error('该手机号已经被注册'))
              //     }
              //   })
              // }
              callback()
            }
          },
          trigger: 'blur'
        }],
        idName: [{ required: true,
          validator: (rule, value, callback) => {
            if (value) {
              callback()
            } else {
              callback(new Error('请输入教练员姓名'))
            }
          },
          trigger: 'blur' }],
        idType: [{
          validator: (rule, val, callback) => {
            if (val) {
              callback()
            } else {
              callback(new Error('请选择证件类型'));
            }
          },
          trigger: 'change'
        }],
        idCountry: [{
          validator: (rule, val, callback) => {
            if (val) {
              callback()
            } else {
              callback(new Error('请选择颁发国家/地区'));
            }
          },
          trigger: 'change'
        }],
        gender: [{ required: true,
          validator: (rule, value, callback) => {
            if (value) {
              callback()
            } else {
              callback(new Error('请选择性别'))
            }
          },
          trigger: 'change' }],
        position: [{ required: true,
          validator: (rule, value, callback) => {
            if (value) {
              callback()
            } else {
              callback(new Error('请选择球员位置'))
            }
          },
          trigger: 'change' }],
        squadUuid: [{ required: true,
          validator: (rule, value, callback) => {
            if (value) {
              callback()
            } else {
              callback(new Error('请选择球队'))
            }
          },
          trigger: 'change' }],
        youthUuid: [{ required: true, message: '请选择单位', trigger: 'change' }],
        unit: [{ required: true,
          validator: (rule, value, callback) => {
            if (value) {
              callback()
            } else {
              callback(new Error('请输入单位名称'))
            }
          },
          trigger: 'blur' }],
        organUuid: [{ required: true, message: '请选择管理单位', trigger: 'change' }],
        password: [{ required: false,
          validator: (rule, value, callback) => {
            if (!value) {
              callback()
            } else {
              if (!rules.password(value)) {
                callback(new Error(this.$t('passwordLimit')))
              } else {
                callback()
              }
            }
          },
          trigger: 'blur' }],
        confirmPassword: [{ required: false,
          validator: (rule, value, callback) => {
            if (value) {
              if (this.coachInfo.password) {
                if (value === this.coachInfo.password) {
                  callback()
                } else {
                  callback(new Error('两次密码不一致'))
                }
              } else {
                if (!rules.password(value)) {
                  callback(new Error(this.$t('passwordLimit')))
                } else {
                  callback()
                }
              }
            } else {
              if (this.coachInfo.password) {
                callback(new Error('两次密码不一致'))
              } else {
                callback()
              }
            }
          },
          trigger: 'blur' }],
        coachLeadYears: [{
          required: true,
          validator: (rule, value, callback) => {
            if (!value && value !==0) {
              callback(new Error('请填写教练员带队年限'))
            } else {
              if (rules.isNumber(value)) {
                callback()
              } else {
                callback(new Error('请输入大于等于0的数字'))
              }
            }
          },
          trigger: 'blur'
        }],
        idNumberPass: '',
        phonePass: ''
      }
    }
  }
}
